import { Component, OnInit } from '@angular/core';
import { DeligateService } from './deligate.service';
import { MatSnackBar } from '@angular/material';
import { SessionStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DeletePopUpComponent } from '../../common/delete-pop-up/delete-pop-up.component';

@Component({
  selector: 'app-deligate',
  templateUrl: './deligate.component.html',
  styleUrls: ['./deligate.component.css']
})
export class DeligateComponent implements OnInit {
  @SessionStorage() public user;
  public delagatelist: Array<any> = [];
  public editMode: boolean = false;
  public data;
  constructor(
    public dialog: MatDialog,
    public deligateService: DeligateService,
    public router: Router,
    public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getDelegationList();
  }

  /**function to add RM to delegate */
  addDelegate() {
    this.data = {
      "data": '',
      "type": "add"
    };
    this.editMode = true;
  }

  /**function to edit RM to delegate */
  editDelegate(delegateData) {
    const date = new Date().getTime();
    const startDate = new Date(delegateData.delegatedFromDate).getTime();
    if (date < startDate) {
      this.data = {
        "data": delegateData,
        "type": "edit"
      };
      this.editMode = true;
    } else {
      this.snackBar.open('Edit Delegation is freezed due to Date/time constraint', 'OK', {
        duration: 5000,
      });
    }
  }

  /**function to get delegation list */
  getDelegationList() {
    this.delagatelist = [];
    this.deligateService.getDelegate(this.user.Empno).subscribe(
      (data) => {
        if (data.payload) {
          data.payload.forEach(value => {
            this.delagatelist.push(value);
          });
        }
      });
  }

  /**function to delete delegated RM */
  deleteDelegate(delegateData) {
    const date = new Date().getTime();
    const startDate = new Date(delegateData.delegatedFromDate).getTime();
    if (date < startDate) {
      if (this.dialog.openDialogs.length === 0) {
        const dialogRef = this.dialog.open(DeletePopUpComponent);
        dialogRef.afterClosed().subscribe(result => {
          if (result == true) {
            this.deligateService.deleteDelegate(delegateData.delegationID).subscribe(
              (data) => {
                this.snackBar.open('Delegate deleted successfully', 'OK', {
                  duration: 5000,
                });
                this.getDelegationList();
              },
              error => {
                this.snackBar.open('Error deleting Delegate', 'OK', {
                  duration: 5000,
                });
              });
          }
        });
      }
    } else {
      this.snackBar.open('Delete Delegation is freezed due to Date/time constraint', 'OK', {
        duration: 5000,
      });
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/rm/deligate/deligate.component.ts